export enum GpsDataStatus {
  Verified = 0,
  InvalidCountry = 1,
  InProgress = 2,
  SetByUser = 3,
}
